import React from 'react';
import {View} from 'react-native';
// import {useStyle} from 'src/providers/style';

const GrowthStrategicMetrics = () => {
  //   const styles = useStyle();

  return <View>Growth and Strategic Metrics</View>;
};

export default GrowthStrategicMetrics;
